import { useUserPackages } from '../queries/useUserPackages'

export const useUserUnshippedPackages = () => {
  return useUserPackages(packages => {
    const unshipped = packages.filter(item => !item.isShipped && !item.isDraft)

    // filter the SUBTRACT packages
    const filteredUnShippedPackages = unshipped.filter(
      p => !(p.delayStatus == '30' || p.delayStatus == 'SUBTRACTED' || p.delayStatus == 'DONATED')
    )
    // filter old SUBTRACT packages.
    return filteredUnShippedPackages.filter(p => !p.delayedPackageId)
  })
}
